<template>
  <div class="trail-audio-slide py-4 py-md-0">
    <router-link
      class="text-light text-decoration-none"
      :to="{
        name: 'audio',
        params: {
          id: resource.id
        }
      }"
    >
      <img :src="img" class="img-fluid" />
      <div>
        <h6>{{ resource.name }}</h6>
        <small class="text-secondary">{{ duration }}</small>
      </div>
    </router-link>
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    resource: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    img() {
      return this.resource.picture || this.resource.thumbnail_vimeo;
    },
    duration() {
      const totalSecs = get(this.resource, "total_duration", 0);
      const s = totalSecs % 60;
      const m = Math.floor(totalSecs / 60) % 60;
      const h = Math.floor(totalSecs / (60 * 60));
      const time = [h, m, s];
      return time.map(i => `${i}`.padStart(2, "0")).join(":");
    }
  }
};
</script>

<style lang="scss" scoped>
.trail-audio-slide {
  a {
    display: flex;
    align-items: center;

    img {
      min-width: 100px;
      min-height: 100px;
      max-width: 100px;
      max-height: 100px;
      object-fit: cover;
      border-radius: 3px;
      margin-right: 16px;
    }

    h6 {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 0;
    }
  }
}
</style>
